import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CUSTOM_COMPONENTS } from '../../../js/customElements/customComponents';
import ChatComponent from '../FloatingSideComponents/ChatComponent';
import { supervisorChatSVG } from '../../../Images/ChatSVG';
import { DRAGGABLE_WINDOWS, WORKBAR_ACTIONS } from '../../../constants'
import { removeWorkAction } from '../../../redux/actions/A_workBar_selected'
import { removeWindow } from '../../../redux/actions/A_draggable_windows_controller'
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { Singleton } from '../../../js/Singleton';

class SuperVisorChatFloating extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    this.language = new Singleton();
  }
  shouldComponentUpdate(next_props, next_state) {
    return false;
  }
  closeChat() {
    this.props.removeWorkAction(WORKBAR_ACTIONS.SUPERVISOR_CHAT);
    this.props.removeWindow(DRAGGABLE_WINDOWS.SUPERVISOR_CHAT);
    this.sharedData.setChatWindowOpen(false);
    this.sharedData.setStateWindow(DRAGGABLE_WINDOWS.SUPERVISOR_CHAT, false);
  }
  render() {
    return (
      <div className="fullSize" onClick={() => this.props.goTopZ(this.props.id)}>
        {CUSTOM_COMPONENTS["draggableHeader"](supervisorChatSVG,
          this.language.getText("GUIChatwindowTitle"),
          () => this.closeChat())}
        <ChatComponent floating={true} objProps={this.props.objProps} />
      </div>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return ({
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    removeWorkAction: (idRemove) => { dispatch(removeWorkAction(idRemove)); },
  });
}
export default SuperVisorChatFloating = connect(
  null,
  mapDispatchToProps
)(SuperVisorChatFloating);



// WEBPACK FOOTER //
// ./src/components/workSpace/floatingWindows/SuperVisorChatFloating.jsx